import PropTypes from 'prop-types';
import Box from 'components/UI/Box/Box';
import { ReactComponent as MedalRibbonsStarLogo } from 'assets/icons/medal-ribbons-star.svg';
import Button from 'components/UI/Button';
import { formatDate } from 'utils/formatDate';
import { ROUTE_PATH } from 'routes';
import { ReactComponent as EyeIcon } from 'assets/icons/eye.svg';
import { formatCurrency } from 'utils/formatCurrency';
import './styles.scss';

const Coupon = ({
  literals,
  coupon,
  onClick,
}) => {
  return (
    <Box className='card-coupon mb-4' padding='sm' onClick={onClick}>
      {/* Two flex columns: the "Ver" button owns its own space (never floats
          over a content row like "Vigencia", WEB_MLS-547) and sits pinned to the
          card's top-right corner (items-start). */}
      <div className='flex items-start gap-3'>
        <div className='flex-1 min-w-0'>
          <div className='flex items-center gap-2 mb-4'>
            <MedalRibbonsStarLogo width={48} />
            <p className='mb-0 font-bold text-lg'>{coupon.description}</p>
          </div>
          <p className='text-sm text-neutral-500 mt-2 mb-2'>{`#${coupon.promotionId}`}</p>
          <div className='flex items-center gap-2 mb-2'>
            <p className='mb-0'>{literals.maxAmount}</p>
            <p className='mb-0 font-semibold'>{formatCurrency(coupon.maxAmount)}</p>
          </div>
          <div className='flex items-center gap-2 mb-2'>
            <p className='mb-0'>{literals.discount}</p>
            <p className='mb-0 font-semibold'>{`${coupon.discount}%`}</p>
          </div>
          {coupon.sections.length ? (
            <div className='flex items-center gap-2 mb-2'>
              <p className='mb-0'>{literals.applyIn}</p>
              <p className='mb-0 font-semibold'>{coupon.sections.map((section) => literals.sections[section] || section).join(', ')}</p>
            </div>
          ) : null}
          {(coupon.couponType || coupon.legacyCouponType) ? (
            <div className='flex items-center gap-2 mb-2'>
              <p className='mb-0'>{literals.couponType}</p>
              <p className='mb-0 font-semibold'>
                {coupon.couponType || literals.legacyCouponType}
              </p>
            </div>
          ) : null}
          <div className='flex items-center gap-2 mb-0'>
            <p className='mb-0'>{literals.life}</p>
            <p className='mb-0 font-semibold'>{formatDate(coupon.endDate, 'DD/MM/YYYY')}</p>
          </div>
          {coupon.autosMessage ? (
            <p className='alert alert-warning text-sm mt-3 mb-0' role='alert'>
              {coupon.autosMessage}
            </p>
          ) : null}
        </div>
        <Button className='bt-coupon shrink-0' to={ROUTE_PATH.setLoyaltyPointsCoupon(coupon.id)}>
          <EyeIcon width={28} height={28} />
        </Button>
      </div>
    </Box>
  );
};

Coupon.propTypes = {
  literals: PropTypes.object.isRequired,
  coupon: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default Coupon;
